import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { BaseURL } from '../helpers/index.js'

const _package = require('../../package.json')
const store_name = `useryaa-${_package.version}`

export const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props =>
			localStorage.getItem(`${store_name}`) ? (
				<Component {...props} auth={rest.auth || false} />
			) : (
				<Redirect to={{ pathname: `${BaseURL}/login`, state: { from: props.location } }} />
			)
		}
	/>
)
